export default __webpack_public_path__ + "static/media/service.3d3a40e7.png";